module.exports = __webpack_public_path__ + "static/media/ad.39ead886.mp4";